import _Toast from "@kibt/meta-ui/es/toast";
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { computed, defineComponent } from '@vue/composition-api';
import yoda from '@ks/yoda-js-sdk';
import { toWork, toProfile } from '@/utils/ikwai';
import { logger } from '@/utils/logger';
import { useBridge } from '@/utils/yoda';
import useStore from '../store';
import { disableWebp } from '@/utils/platform';
import { getCdnImg } from '@/utils/cdn';
import MyVideo from './video.vue';
export default defineComponent({
  components: {
    MyVideo: MyVideo
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    play: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, ctx) {
    var store = useStore();
    var doFollowing = false; // 关注或取消关注

    var changeFollow = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(currentUserId, currentFollowing) {
        var namespace, canuseRes, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!doFollowing) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                logger.kwailog.sendClick({
                  action: 'FOLLOW_BUTTON'
                });
                doFollowing = true;
                _context.next = 6;
                return yoda.ready();

              case 6:
                namespace = 'business'; // 老版本兼容

                _context.next = 9;
                return yoda.tool.canIUse({
                  namespace: namespace,
                  name: 'changeFollowStatus'
                });

              case 9:
                canuseRes = _context.sent;

                if (!canuseRes.canUse) {
                  namespace = 'bussiness';
                }

                _context.next = 13;
                return useBridge(namespace, 'changeFollowStatus', {
                  toFollow: !currentFollowing,
                  toUid: currentUserId.toString()
                });

              case 13:
                res = _context.sent;
                doFollowing = false;

                if (res.result === 1) {
                  _Toast.show({
                    text: currentFollowing ? 'Deixou de seguir' // 已取消关注
                    : 'Sucesso'
                  });

                  store.sendBlackCustomLog('clickToFollow');
                  store.changeFollowingMap(currentUserId, !currentFollowing);
                } else {
                  _Toast.show({
                    // 这里为true，说明用户已关注，想取消但失败了
                    text: 'Ocorreu um erro, tenta de novo'
                  });
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function changeFollow(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(); // urls存放假设可用的url，然后最后找出第一个可用的url


    var computedCoverUrl = computed(function () {
      var urls = [props.item.cover_thumbnail_urls, props.item.cover_first_frame_urls];

      if (disableWebp) {
        urls.unshift([{
          cdn: '',
          url: props.item.coverUrl
        }]);
      }

      var urlStrings = urls.map(function (item) {
        return getCdnImg(item);
      }).filter(Boolean);
      return urlStrings[0];
    });
    return {
      toWork: toWork,
      changeFollow: changeFollow,
      store: store,
      toProfile: toProfile,
      computedCoverUrl: computedCoverUrl,
      getCdnImg: getCdnImg
    };
  }
});